module.exports = __webpack_public_path__ + "img/prize-01.90a3f02e.png";